import React from 'react';

export function getCssSize(value: number | string): string {
  return typeof value === 'number' ? `${value}px` : value;
}

export function getDataRole(dataRole?: string, dataRoleAttribute?: string): string | undefined {
  return dataRole ?? dataRoleAttribute;
}

export function getDataName(dataName?: string, dataNameAttribute?: string): string | undefined {
  return dataName ?? dataNameAttribute;
}

export function getItemKey(item: React.ReactNode, index: number): React.Key {
  return typeof item === 'string' || typeof item === 'number' ? item : index;
}
